var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiOptionBase',_vm._g(_vm._b({attrs:{"fullItemList":_vm.optionList,"displayedKey":"name","mode":"includeExclude"},on:{"includeExclude":( inclusiveList, exclusiveList ) => _vm.$emit( 'updatedLists', inclusiveList, exclusiveList )}},'MultiOptionBase',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }